// extracted by mini-css-extract-plugin
export default {"container":"Posts_container__-RSHT","postsGrid":"Posts_postsGrid__bE+Ym","postCard":"Posts_postCard__eE-pT","postImage":"Posts_postImage__tTmve","readMore":"Posts_readMore__cqSso"};